/* eslint no-unused-vars: 0 */
import $ from 'jquery';
import accordionItemToggle from "./accordionItemToggle";
import formAjax from './form-ajax';
import initCookiePopup from './cookie-popup';
import initScrollTo from './scroll-to';
import mobileMenu from './mobile-menu';
import sideMenu from './sidemenu';
import toggleMapFilterView from "./toggle-map-filter-view";

$(document).ready(() => {
    const $cookiePopup = $('.js-cookie-popup');
    if ($cookiePopup.length) {
        $cookiePopup.map((i, v) => initCookiePopup(v));
    }

    const $jsScrollTo = $('.js-scroll-to');
    if ($jsScrollTo.length) {
        $jsScrollTo.map((i, v) => initScrollTo(v));
    }

    const $jsMobileMenu = $('.js-toggle-menu');
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $jsSideMenu = $('.js-toggle-sidemenu');
    if ($jsSideMenu.length) {
        $jsSideMenu.map((i, v) => sideMenu(v));
    }

    const $jsAccordion = $(".js-accordion");
    if ($jsAccordion.length) {
        $jsAccordion.map((i, v) => accordionItemToggle(v));
    }

    const $formAjax = $('.js-form-ajax');
    if ($formAjax.length) {
        $formAjax.map((_i, v) => formAjax(v));
    }

    const $toggleMapFilterView = $(".js-map-view-filters");
    if ($toggleMapFilterView.length) {
        $toggleMapFilterView.map((i, v) => toggleMapFilterView(v));
    }

});
